import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("apc_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setCurrentUser(data))
      .catch(() => sessionStorage.removeItem("apc_token"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted && !sessionStorage.getItem("apc_token")) {
        window.location.replace("/login");
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    sessionStorage.setItem("apc_token", data.access_token);
    setCurrentUser(data.user);
    return data.user;
  };

  const logout = () => {
    sessionStorage.removeItem("apc_token");
    setCurrentUser(null);
  };

  return (
    <AuthContext.Provider value={{ currentUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
